import axiosPost from "../axiosPost";

export const hotelUpd = async (params = {}, credentials) => {
    const body = {
        service: "SFHotelUpd",
        params: {
            SFHotelId: params?.SFHotelId,
            SFHotelNombre: params?.SFHotelNombre,
            SFHotelDomicilioCalle: params?.SFHotelDomicilioCalle,
            SFHotelDomicilioCasa: params?.SFHotelDomicilioCasa,
            SFHotelDomicilioCPA: params?.SFHotelDomicilioCPA,
            localidadId: params?.localidadId,
            SFHotelLatitud: params?.SFHotelLatitud,
            SFHotelLongitud: params?.SFHotelLongitud,
            SFHotelCUIT: params?.SFHotelCUIT,
            SFHotelCheckin: params?.SFHotelCheckin,
            SFHotelCheckout: params?.SFHotelCheckout,
            SFHotelVersion: params?.SFHotelVersion,
            SFHotelStatus: params?.SFHotelStatus,
            SFHotelEmail: params?.SFHotelEmail,
            SFHotelTelefono: params?.SFHotelTelefono,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
